// js
import React from 'react';
import PropTypes from 'prop-types';
import Modal from './Modal';
import Button from './Button';
// css
import '../../styles/components/common/ConfirmationModal.scss';


function ConfirmationModal({ open, text, cancelButtonLabel, submitButtonLabel, onCancel, onSubmit }) {
  return (
    <Modal
      className='confirmation-modal'
      open={open}
      dismissable={false}
    >
      <div className='modal-text'>
        {text}
      </div>
      <div className='modal-buttons'>
        <Button
          primary={false}
          onClick={onCancel}
          label={cancelButtonLabel}
        />
        <Button
          primary
          onClick={onSubmit}
          label={submitButtonLabel}
        />
      </div>
    </Modal>
  );
}

ConfirmationModal.defaultProps = {
  open: false,
  text: 'Are you sure?',
  cancelButtonLabel: 'No',
  submitButtonLabel: 'Yes'
};

ConfirmationModal.propTypes = {
  open: PropTypes.bool,
  text: PropTypes.string,
  cancelButtonLabel: PropTypes.string,
  submitButtonLabel: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default ConfirmationModal;



// WEBPACK FOOTER //
// ./src/components/common/ConfirmationModal.js